/**
 * The `Intl` formatters this package runs, built once per argument set.
 *
 * Constructing a formatter costs tens of microseconds; calling `.format()` on
 * one costs a fraction of one. A thousand-row admin table with three date
 * columns constructs three thousand formatters it immediately throws away,
 * which is tens of milliseconds of main-thread time spent on nothing. The
 * objects are immutable and their output depends only on their arguments, so
 * one per distinct argument set serves every call.
 *
 * The viewer's zone is resolved when a formatter with no explicit `timeZone` is
 * built, so a process whose zone changes underneath it keeps rendering in the
 * zone it started in. That is the same reload boundary a page already has.
 */
/**
 * The call shapes in the codebase are a handful, but `locale` is a caller's
 * string and nothing stops it varying per row, so the cache has a ceiling and
 * empties at it. A formatter is cheap to rebuild; a map that grows for the life
 * of a tab is not.
 */
const MAX_CACHED = 64;
const numberFormatters = new Map();
const dateFormatters = new Map();
function cached(store, key, build) {
    const hit = store.get(key);
    if (hit)
        return hit;
    if (store.size >= MAX_CACHED)
        store.clear();
    const built = build();
    store.set(key, built);
    return built;
}
export function numberFormatter(locale, options) {
    return cached(numberFormatters, `${locale} ${JSON.stringify(options)}`, () => new Intl.NumberFormat(locale, options));
}
export function dateFormatter(locale, options) {
    return cached(dateFormatters, `${locale} ${JSON.stringify(options)}`, () => new Intl.DateTimeFormat(locale, options));
}
